
import { mapGetters, mapMutations, mapActions } from "vuex";
import search from "@/components/common/search.vue";
import resouceTab from "@/components/common/resourceTab.vue";
import dropdown from "@/components/common/dropdown.vue";
import loading from "@/components/common/loading";
import empty from "@/components/common/empty";
import rightnavSlide from "@/components/mixins/rightnavSlide";
import Analysis from "@/components/mixins/analysis/materialBu";
import materialPayTypeSubscript from "@/components/common/materialPayTypeSubscript";
import vipBadge from '@/components/mixins/vipBadge';

export default {
  mixins: [rightnavSlide, Analysis, vipBadge],

  props: {},
  components: {
    search,
    dropdown,
    resouceTab,
    loading,
    empty,
    materialPayTypeSubscript
  },
  data() {
    return {
      searchVal: "",
      isFocused: false,
      loading: 0,
      searchTab: "all",
      showSearch: false,
      playActiveId: null,
      musicer: {
        current: {},
        play: false,
        currentTime: 0, //当前播放时间
        duration: 0,
      },
      vipDefault: {
        name: "付费权限",
        value: null,
      },
      sourceScreen: [
        {
          name: "道具",
          type: "prop",
        }, {
          name: "形状",
          type: "shape",
        }, {
          name: "GIF",
          type: "gif",
        },
      ],
      // vipScreen: [
      //   { name: "全部", value: null },
      //   { name: "免费", value: "free" },
      //   // { name: "付费", value: "pay" },
      //   { name: "会员专属", value: "person" },
      //   { name: "企业会员专属", value: "company" },
      // ],
      // sourcevipScreen: [
      //   { name: "全部", value: null },
      //   { name: "免费", value: "free" },
      //   { name: "付费", value: "pay" },
      //   { name: "会员专属", value: "person" },
      //   { name: "企业会员专属", value: "company" },
      // ],
      stateList: [
        { label: "全部", value: null },
        { label: "可编辑", value: 30 },
        { label: "不可编辑", value: 11 },
      ],
      durationData: [
        {
          name: "全部时长",
          durationMin: "",
          durationMax: "",
        },
        {
          name: "30s以内",
          durationMin: 0,
          durationMax: 30,
          data: "0,30",
          // type : 'static',
        },
        {
          name: "31-60s",
          data: "31,60",
          durationMin: 31,
          durationMax: 60,
          // type : 'dynamic'
        },
        {
          name: "1分钟-2分钟",
          data: "60,120",
          durationMin: 60,
          durationMax: 120,
        },
        {
          name: "2分钟-3分钟",
          data: "120,180",
          durationMin: 120,
          durationMax: 180,
        },
        {
          name: "3分钟以上",
          data: "180,600",
          durationMin: 180,
          durationMax: 600,
        },
      ],
    };
  },
  computed: {
    ...mapGetters([
      'IsOldUser'
    ]),
    vipScreen () {
      if (this.IsOldUser) {
        return [
          { name: "全部", value: null },
          { name: "免费", value: "free" },
          // { name: "付费", value: "pay" },
          { name: "会员专属", value: "person" },
          { name: "企业会员专属", value: "company" },
        ]
      }
      return [
        { name: "全部", value: null },
        { name: "免费", value: "free" },
        // { name: "付费", value: "pay" },
        { name: this.getOptionName(6), value: "company" },
        { name: this.getOptionName(4), value: "person" },
      ]
    },
    sourcevipScreen () {
      if (this.IsOldUser) {
        return [
          { name: "全部", value: null },
          { name: "免费", value: "free" },
          { name: "付费", value: "pay" },
          { name: "会员专属", value: "person" },
          { name: "企业会员专属", value: "company" },
        ]
      }
      return [
        { name: "全部", value: null },
        { name: "免费", value: "free" },
        { name: "付费", value: "pay" },
        { name: this.getOptionName(6), value: "company" },
        { name: this.getOptionName(4), value: "person" },
      ]
    }
  },
  watch: {
  },
  created() { },
  mounted() {

  },
  methods: {
    ...mapActions({
      likes: "resources/likes",
      setRecent: "resources/setRecent",
    }),
    useMusic(item) {
      this.$modal.show("SubtitleMessageDialog", {
        view: "Common",
        msg: "是否要将该配乐设置为全局循环播放?",
        okText: "循环播放",
        cancelText: "单曲加入",
        resultCallback: (value) => {
          if (value && value.type == "Ok") {
            let mArr = this.$store.getters['addSoundtrack/getMusicArr'];
            let len0 = mArr.length;
            this.$store.commit("addSoundtrack/setTotalTime", this.getTimes()[0]);
            this.$store.commit("addSoundtrack/chooseMusicLoop", item);
            // this.$store.commit('addSoundtrack/setSoundObj', this.$store.getters['addSoundtrack/getPlayHandle']);
            let len1 = mArr.length;
            this.$bus.emit('checkMaterial.music', mArr);
            if (len0 === 0 && len1 === 1) {
              // emit
            }
            this.$message({
              message: "配乐循环设置成功",
              type: "success",
            });
            this.setRecent({ type: "sound", id: item.id }).then((res) => {
            });
          } else if (value && value.type == "Cancel") {
            this.setMusic(item);
            let mArr = this.$store.getters['addSoundtrack/getMusicArr'];
            this.$bus.emit('checkMaterial.music', mArr);
            this.materialPushAnalysis({
              type: "music",
              id: item.id,
              name: item.name,
            });
          }
        },
      });
    },
    getTimes() {
      let times = [0, 0];
      if (!this.TOOL) return times;
      for (let i = 0; i < this.TOOL.sprites.length; i++) {
        if (this.SelectScenes_Msg.index === i) times[1] = times[0];
        times[0] += this.TOOL.sprites[i].duration;
      }
      times[0] /= 1000;
      times[1] /= 1000;
      return times;
    },
    notLogged(res) {//当前没有登录提示
      if (res.code === 403) {
        this.$message("您还未登录,不能查看收藏数据");
        this.collectMaterialData = [];
        this.loading = 1;
        return;
      }
    },
    // 收藏素材
    getFavorite({ id, flag, type, favorites }) {
      this.likes({ id: id, flag: flag, type: type }).then(
        (data) => {
          this.SetToast(data, favorites);
        }
      );
    },
    SetToast(data, favorite) {//设置收藏提示
      if (data.code === 403) {
        this.$message("您还未登录,不能查看收藏数据");
        this.collectMaterialData = [];
        this.loading = 1;
        return;
      } else if (data.code === 200) {
        if (favorite == true) {
          this.$message({
            message: "收藏成功",
            type: "success",
          });
        } else {
          this.$message("收藏已取消");
        }
      } else if (data.code === 412) {
        this.$message(data.msg);
      }

    },
    onFocusAction(data) {
      this.isFocused = data;
    },
    searchingProps(isFocused, type, keyword) {
      return {
        status: isFocused,
        type: type,
        keyVal: keyword,
      }
    },
    playAudio(item) {
      if (this.playActiveId == item.id) {
        this.musicer.play = !this.musicer.play;
      } else {
        this.musicer.play = true;
        this.playActiveId = item.id;
        this.musicer.currentTime = 0;
        this.$refs.musicPlay.currentTime = 0;
      }
      this.musicer.current = item;
      this.musicPlayer();
    },
    musicPlayer() {
      if (this.musicer.play == true) {
        setTimeout(() => {
          //设置延迟执行
          this.$refs.musicPlay.play();
        }, 500);
      } else {
        this.$refs.musicPlay.pause();
      }
    },
    getAudioLength: function () {
      //获取视频的时长
      if (this.$refs.musicPlay) {
        this.musicer.duration = this.$refs.musicPlay.duration;
      }
    },
    audioTimeUpdate: function () {
      let time = this.$refs.musicPlay.currentTime;
      if (this.$refs.musicPlay.duration) {
        if (time == this.musicer.duration) {
          this.$refs.musicPlay.pause();
          this.musicer.play = false;
        }
      }
    },
    stopPreviewItem(e) {
      if (this.previewTimer) {
        clearTimeout(this.previewTimer);
      }
      if (this.lottiedata) {
        this.lottiedata.stop();
        this.lottiedata.destroy();
        this.lottiedata = null;
      }
    },
    startPreviewItem(item, index) {
      if (this.previewTimer) {
        clearTimeout(this.previewTimer);
      }
      this.previewTimer = setTimeout(() => {
        let option = {
          container: this.$refs["lottie" + index][0],
          renderer: "svg",
          loop: true,
          autoplay: false,
          path: this.$handleAssetsUrl(item.url),
        };
        this.lottiedata = lottie.loadAnimation(option);
        this.lottiedata.play();
        clearTimeout(this.previewTimer);
      }, 100);
    },
  },
};




// WEBPACK FOOTER //
// ./src/components/mixins/resourcesArea/getResourcesCommon.js